/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import classes from "./ModalOnboardingStart.module.scss";
import modalCloseButton from "./../../../assets/images/onboarding/modal_close_button.svg";
import afinandoStartTour from "./../../../assets/images/afinando_start_tour.svg";
import caretCircleRight from "./../../../assets/images/onboarding/caret_circle_right.svg";
import SystemContext from "../../../context/SystemContext";
import { useDispatch, useSelector } from "react-redux";

const ModalOnboardingStart = ({
  setRun,
  openModalStart,
  setOpenModalStart,
}) => {
  const [content, setContent] = useState(true);
  const { activeUser, session } = useSelector((state) => state.session);

  const user_sub = session && session.sub;

  const dispatch = useDispatch();

  useEffect(() => {
    setContent(
      session && openModalStart ? (
        <div className={classes.WrapModal}>
          <div className={classes.ModalDefault}>
            <div className={classes.ModalDefaultTop}>
              <div className={classes.Title}>{"Bem-vindo!"}</div>
              <button
                className={classes.ButtonClose}
                onClick={() => {
                  localStorage.setItem("onboarding", "viewed");
                  dispatch({
                    type: "SET_TOUR",
                    payload: {
                      tour: { id: "default", sub: user_sub },
                    },
                  });
                  setOpenModalStart(false);
                }}
              >
                <img src={modalCloseButton} alt="close button" />
              </button>
            </div>
            <div className={classes.ModalDefaultBottom}>
              <div className={classes.ModalTextArea}>
                Agradecemos por se juntar a nós!
              </div>
              <div className={classes.ModalTextArea}>
                Que tal um tour rápido para conhecer e aproveitar melhor os
                recursos do Afinando?
              </div>
              <img src={afinandoStartTour} alt="close button" />
              <button
                onClick={() => {
                  localStorage.setItem("onboarding", "viewed");
                  dispatch({
                    type: "SET_TOUR",
                    payload: {
                      tour: { id: "default", sub: user_sub },
                    },
                  });
                  setOpenModalStart(false);
                  setRun(true);
                }}
                className={classes.ButtonStartTour}
              >
                Iniciar Tour
                <img src={caretCircleRight} alt="close button" />
              </button>
              <button
                onClick={() => {
                  localStorage.setItem("onboarding", "viewed");
                  dispatch({
                    type: "SET_TOUR",
                    payload: {
                      tour: { id: "default", sub: user_sub },
                    },
                  });
                  setOpenModalStart(false);
                }}
                className={classes.ButtonSkip}
              >
                Não quero fazer o tour agora{" "}
              </button>
            </div>
          </div>
        </div>
      ) : null
    );
  }, [session, openModalStart]);

  return content;
};
export default ModalOnboardingStart;
